import apiClient from "utils/apiClient";


export const TIMELINE_EVENT_TYPES = [
  {
    value: "WEBSITE_CREATED",
    label: "Website created",
    category: "activity",
    icon: "circle-plus",
  },
  {
    value: "TEMPLATE_SELECTED",
    label: "Template selected",
    category: "activity",
    icon: "layout-grid",
  },
  {
    value: "GENERATION_STARTED",
    label: "Generation started",
    category: "activity",
    icon: "player-play",
  },
  {
    value: "GENERATION_COMPLETED",
    label: "Generation completed",
    category: "activity",
    icon: "circle-check",
  },
  {
    value: "WEBSITE_UPDATED",
    label: "Website/section updated",
    category: "activity",
    icon: "edit",
  },
  {
    value: "PUBLISHING_STARTED",
    label: "Publishing started",
    category: "activity",
    icon: "cloud-upload",
  },
  {
    value: "PUBLISHING_COMPLETED",
    label: "Publishing completed",
    category: "activity",
    icon: "world",
  },
  {
    value: "TEMPLATE_RENDER_FAILURE",
    label: "Template rendering failure",
    category: "error",
    icon: "alert-triangle",
  },
  {
    value: "FILE_UPLOAD_FAILURE",
    label: "File upload failure",
    category: "error",
    icon: "file-x",
  },
  {
    value: "CONTENT_VALIDATION_FAILURE",
    label: "Content validation failure",
    category: "error",
    icon: "alert-octagon",
  },
  {
    value: "PUBLISHING_FAILURE",
    label: "Publishing failure",
    category: "error",
    icon: "cloud-off",
  },
];

const TYPE_MAP = Object.fromEntries(
  TIMELINE_EVENT_TYPES.map((t) => [t.value, t]),
);

function cleanParams(params) {
  return Object.fromEntries(
    Object.entries(params).filter(
      ([, v]) => v !== "" && v !== null && v !== undefined,
    ),
  );
}

function enrich(e) {
  const meta = TYPE_MAP[e.type];
  return {
    ...e,
    category: meta?.category ?? e.category?.toLowerCase(),
    label: meta?.label ?? e.type,
    icon: meta?.icon ?? "circle",
  };
}

export async function fetchTimelineEvents({
  query = "",
  category = "",
  type = "",
  range = "all",
} = {}) {
  const { data } = await apiClient.get(
    "/ovizia-service/api/v1/admin/timeline-events",
    {
      params: cleanParams({
        query,
        // The hook tracks category as lowercase ("activity"/"error") to match
        // the UI toggle labels, but the backend's TimelineCategory enum param
        // only accepts exact enum names (ACTIVITY/ERROR) — Spring's default
        // converter is case-sensitive and 500s on a mismatch. Same risk for
        // `type` if it's ever passed lowercase, so both are normalized here
        // rather than pushing this concern onto every caller.
        category: category ? category.toUpperCase() : "",
        type: type ? type.toUpperCase() : "",
        range,
        page: 0,
        size: 100,
      }),
    },
  );
  return data.content.map(enrich);
}
